import BaseDialog from "./BaseDialog.vue";
export default BaseDialog;
